import React, { Component } from "react";
import { connect } from "react-redux";
import "./NewProject.scss";
import Section from "./../../components/Section/Section";
import FormDialog from "./../../components/Form-Dialog/Form-Dialog";
import axios from "axios";
import qs from "query-string";
import * as actionTypes from "../../store/actions";
import $ from "jquery";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { Dropdown } from "semantic-ui-react";
import Axios from "axios";
import Button from "@material-ui/core/Button";
// dialog dependencies
import Dialog from "@material-ui/core/Dialog";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
import InputMask from "react-input-mask";
import { Redirect } from "react-router-dom"; //make sure to import all the components.
import ReactLoader from "react-loader-spinner";
import postalCodes from "postal-codes-js";
import Translated from "../../components/Translated/Translated";
import translator from "../../utils/translator";

// Looked on the internet and this is the best way to keep the initial state. we will be using this to fix the problem when the user clicks on new project
// for some reason new project does not reload the page when you are currently on it . We used this variable in componentWillReceiveProps life cycle hook
const initialState = {
	//customer input fields states
	firstName: "",
	lastName: "",
	address: "",
	city: "",
	province: "",
	postalCode: "",
	emailAddress: "",
	phoneNumber: "",
	mobilePhoneNumber: "",
	customerId: "", //we will need this to check if we are updating a customer information or creating a new one for the createOrUpdate event handler function
	//project information input fields states
	projectId: "",
	projectName: "",
	projectAddress: "",
	projectCity: "",
	projectProvince: "",
	projectPostalCode: "",
	warehouseNumber: "",
	accountName: "",
	accountId: "", //we will use this to get the ship tos
	listOfAccounts: [],
	shipTo: "",
	actingAgent: false,
	//project rooms
	sectionName: "",
	isThisANewProject: false,
	reRender: false, //used to force the component to re render. I used this to display the new changes when you add a new project room
	passReactStateToProductShoppingPage: false, //used when clicking the confirm button to go to the product shopping screen. that way we can keep the roomNames for the checkbox when opening the product information dialog
	validationMessage: "",
	//used for dropDown component
	listOfContactInfo: [],
	isThisAnExistingContactInfo: false,
	oldRoomName: "", // This is used if the user enters no name for a room. It will revert back to this name. This is used in the changeRoomTitle and save_room_title function of this file

	// Changes to sections/rooms
	rooms: [],
	roomsLoading: 0,

	// For the search input
	searchTimeout: null,

	listOfShipTos: [],

	updatedProjectPriceDialog: null,

	// this state is used when ever you have to redirect the user
	redirect: null,

	// States used to check if validation is approved to decide if we should display the quote and product shopping link on the header using redux to tell the header component to display it. There is a function in this component that checks if these 3 states are true.
	// UPDATED - Set the project_info_form_validation_approved to true by default since createOrUpdateProject is no longer run when the page loads. This allows Quote and Product Shopping to show in the nav
	customer_form_validation_approved: false,
	project_info_form_validation_approved: true,
	room_form_validation_approved: false,
	did_we_change_room_title: false,
	isDisabled: false,
	accountQuery: '', // Basically a copy of accountName used for validations/preventing improper success messages
	warehouseDisabled: false,
	warehouseRooms: [],
	roomTitleDialogOpen: false,
	roomTitleDialogLoading: null,
	warehouseRoomsToAddToRooms: [],
	shipToQuery: '',
};

export class NewProject extends Component {
	constructor(props) {
		super(props);
		this.state = initialState;
		this.finishedMountLoad = false;
	}

	componentDidUpdate(prevProps, prevState, snapshot) {
		if (this.props.location.search === "" && this.state.isThisANewProject === false) {
			// the reason we have && is because we don't want to reload the page when the user created a new room because in that function we update the redux props but it does have location.search as ''. This only happens when we create a new project from scratch
			window.location.reload();
		}
		if (this.finishedMountLoad && this.state.warehouseNumber !== prevState.warehouseNumber) {
			this.setState({
				accountId: "",
				listOfAccounts: [],
				shipTo: "",
				listOfShipTos: [],
			});
		}
	}

	async componentDidMount() {
		let projectId = qs.parse(this.props.location.search, {
			ignoreQueryPrefix: true
		}).projectId;

		if (projectId) {
			let getProjectInformationURL =
				this.props.APIUrl + "/projects/info?project_id=" + projectId;

			let projectInformation = await axios.get(getProjectInformationURL);

			//set the state of for the customer input fields
			await this.setState({
				firstName: projectInformation.data.customerInformation.fname,
				lastName: projectInformation.data.customerInformation.lname,
				address: projectInformation.data.customerInformation.address,
				city: projectInformation.data.customerInformation.city,
				postalCode: projectInformation.data.customerInformation.postal,
				province: projectInformation.data.customerInformation.province,
				emailAddress: projectInformation.data.customerInformation.email,
				phoneNumber: projectInformation.data.customerInformation.phone_day.replace("-", ""),
				mobilePhoneNumber: projectInformation.data.customerInformation.phone_mobile.replace(
					"-",
					""
				)
			});

			//set the state for the project information input fields
			await this.setState({
				projectName: projectInformation.data.projectInformation.title,
				projectAddress: projectInformation.data.projectInformation.address,
				projectCity: projectInformation.data.projectInformation.city,
				projectProvince: projectInformation.data.projectInformation.province,
				projectPostalCode: projectInformation.data.projectInformation.postal,
				warehouseNumber: projectInformation.data.projectInformation.warehouse,
				accountName: projectInformation.data.projectInformation.account_name,
				accountQuery: projectInformation.data.projectInformation.account_name,
				shipTo: projectInformation.data.projectInformation.ship_to,
				shipToQuery: projectInformation.data.projectInformation.ship_to,
				actingAgent: projectInformation.data.projectInformation.acting_agent, //fix this later it's not working
				customerId: projectInformation.data.projectInformation.customer_id, //we will need this to check if we are updating a customer information or creating a new one for the createOrUpdate event handler function
				projectId: projectInformation.data.projectInformation.id,
				projectLevelId: projectInformation.data.project_rooms[0]
					? projectInformation.data.project_rooms[0].level_id
					: false,
				accountId: projectInformation.data.projectInformation.account_id,
				listOfAccounts: [
					{
						text: projectInformation.data.projectInformation.account_name,
						value: projectInformation.data.projectInformation.account_id
					}
				]
			});

			// Check if acting as an agent is true or false. and have it checked using jquery cause i didn't know how else i can do it
			if (this.state.actingAgent) {
				$("#actingAgentToggle").prop("checked", true);
			}

			// save acting as an agent to redux because we will need this on the quote screen
			this.props.saveActingAsAnAgent(this.state.actingAgent);

			//set the state for the project rooms
			let projectRooms = await projectInformation.data.project_rooms.map((room, index) => (
				<Section
					sectionName={room.title}
					sectionNumber={index}
					roomId={room.id}
					projectId={this.state.projectId}
				/>
			));

			// The reason i didn't just put projectRooms with projectRoomsId into a object is because i created the line below near the end of the project
			// SO most of the component is currently using projectRooms and I will have to refactor a lot of code.
			// but don't worry they are in the same order and the only place we use the room id is in the product shopping page
			// in the roomQuantityInput child component. room name and id is in the same order. i know this is really bad.
			let projectRoomIds = await projectInformation.data.project_rooms.map(
				(room, index) => room.id
			);

			// We will use this in the product shopping screen to display the list of rooms with checkboxes so we can add products to it.
			let roomNames = [];
			for (let i = 0; projectInformation.data.project_rooms.length > i;) {
				roomNames.push(projectInformation.data.project_rooms[i].title);
				i++;
			}
			await this.props.saveProjectRooms(projectRooms, roomNames, projectRoomIds);

			this.setState({ rooms: projectInformation.data.project_rooms });

			if(!!this.state.shipTo) {
				await this.getShipTosSearch(this.state.shipTo);
			} else {
				await this.getShipTosForThisAccountId(); //we don't pass anything because we use the state in that function
			}

			// Change the redux state to display the check prices button on the header
			// Could not think of any other way because this component is not a direct decendant child of the header component.
			// It will be more code than if i were to just use redux
			await this.props.displayCheckPricesButtonOnNavBar(true);
			await this.props.displayCheckProductDetailsOnNavBar(true);

			// put all of this in a function so when ever you click confirm/call one of the validation form functions it will run this block of code to decide if we should display it on the nav bar.
			await this.createOrUpdateCustomer(null, true);
			await this.updateProjectRooms(null, true);
			await this.getSavedRoomsFromWarehouse();
		} else {
			await this.setState({
				isThisANewProject: true
			});

			// clear all the room data if any. So, it does contain old project you visited rooms
			this.props.saveProjectRooms([], [], []);

			// have the other two cards grayed out and unclickable
			$("#project-information").addClass("disabled");

			$("#create-rooms").addClass("disabled");

			// Set up the dropdown search for contact info

			// Get the trend password and trendId so we can pass it to the backend and get the account information through trend and set the state because we use it through out this script

			const getListOfContactInfoAPIUrl = this.props.APIUrl + "/customers/search-customers";

			const getListOfContactInfoAPIResponse = await axios.post(getListOfContactInfoAPIUrl, {
				query: ""
			});
			let listOfContactInfo = getListOfContactInfoAPIResponse.data.listOfContactInfo;
			const listOfContacts = [];

			for (let i = 0; i < listOfContactInfo.length;) {
				let formatDataForInputDropDown = {
					text:
						listOfContactInfo[i].fname +
						" " +
						listOfContactInfo[i].lname +
						" | " +
						listOfContactInfo[i].address +
						" | " +
						listOfContactInfo[i].phone_day,
					value: JSON.stringify(listOfContactInfo[i]) // we are going to use this to extract the value and insert it into the input field
				};

				listOfContacts.push(formatDataForInputDropDown);

				i++;
			}

			this.setState({ listOfContactInfo: listOfContacts });


			let default_project_response = await Axios.post(
				this.props.APIUrl + "/projects/fetch-default",
				{ trendId: localStorage.getItem("trendId") }
			);
			if (!!default_project_response.data.getDefaultProjectForTrendUser) {
				let default_project = default_project_response.data.getDefaultProjectForTrendUser;
				this.setState({
					projectName: default_project.title,
					warehouseNumber: default_project.warehouse,
					accountId: default_project.account_id,
					accountName: default_project.account_name + " | " + default_project.account_id,
					listOfAccounts: [
						{
							text: default_project.account_name + " | " + default_project.account_id,
							value: default_project.account_id
						}
					],
					shipTo: default_project.ship_to,
					projectAddress: default_project.address,
					projectCity: default_project.city,
					projectProvince: default_project.province,
					projectPostalCode: default_project.postal,
					accountQuery: default_project.account_name + " | " + default_project.account_id,
					shipToQuery: default_project.ship_to,
				});
				if (!!default_project.account_id) {
					await this.getShipTosForThisAccountId();
				}
			}

			let consultantWarhouse = await Axios.post(
				this.props.APIUrl + "/consultant/check-warehouse",
				{ trendId: localStorage.getItem("trendId") }
			);

			// If consultant has one warehouse, and no default already set, use their primary warehouse
			// Also prevent the consultant from editing it
			if(!!consultantWarhouse.data.warehouse && !this.state.warehouseNumber) {
				this.setState({
					warehouseNumber: consultantWarhouse.data.warehouse,
					warehouseDisabled: true
				});
			}
		}
		this.finishedMountLoad = true;
	}

	// -- THIS IS WHERE I LEFT OFF --
	// instead of returning true in each of those functiosn I think we should just have 3 states to check if they are true because if you return true and use this function to call everything you click confirm you will have an infinite loop
	check_if_we_should_display_product_shopping_and_quote_on_nav_bar = async () => {
		if (
			this.state.customer_form_validation_approved &&
			this.state.project_info_form_validation_approved &&
			this.state.room_form_validation_approved
		) {
			await this.props.display_quote_link_on_nav_bar(true);
			await this.props.displayProductShoppingButtonOnNavBar(true, this.state.warehouseNumber);
		} else {
			await this.props.display_quote_link_on_nav_bar(false);
			await this.props.displayProductShoppingButtonOnNavBar(false);
		}
	};

	getShipTosForThisAccountId = async eventTargetValue => {
		if (eventTargetValue) {
			// we also need to get the account name to update the database
			let selectedAccountIndex = this.state.listOfAccounts.findIndex(
				account => account.value === eventTargetValue
			);

			await this.setState({
				accountId: eventTargetValue,
				shipTo: "",
				shipToQuery: "",
				accountName: this.state.listOfAccounts[selectedAccountIndex].text,
				accountQuery: this.state.listOfAccounts[selectedAccountIndex].text
			}); // THIS RIGHT HERE PROVES THAT YOU SHOULD JUST USE AWAIT IN EVERY FUNCTION TO MAKE THE CODE SYNCHRNOUS. AWAIT MAKES THE FUNCTION A PROMISE. If you remove await from this.setState() it will not work the way you want it to. try and see for your self. Also, ignore your code editor message telling you await is uneccessary here. VS Code is dumb and lying to you.
		}

		let trendId = localStorage.getItem("trendId");
		let token = localStorage.getItem("token");

		const getShipToAPIUrl = this.props.APIUrl + "/projects/fetch-ship-to";

		const data = {
			trendId,
			token,
			projectAccountId: this.state.accountId,
			warehouse: this.state.warehouseNumber
		};

		const getShipToAPIResponse = await Axios.post(getShipToAPIUrl, data);
		let listOfShipTosFromTrend = getShipToAPIResponse.data.listOfShipTosFromTrend;

		const listOfShipTos = [];

		// The reason we have an else statement here is because it crashes when you loop through a non array
		// so the else statement does not have a for loop.
		if (Array.isArray(listOfShipTosFromTrend)) {
			for (let i = 0; i < listOfShipTosFromTrend.length; i++) {
				let formatDataForDropDown = {
					text:
						listOfShipTosFromTrend[i].ShipTo +
						" | " +
						listOfShipTosFromTrend[i].CustomerNumber +
						" | " +
						listOfShipTosFromTrend[i].Name,
					value: listOfShipTosFromTrend[i].ShipTo
				};

				listOfShipTos.push(formatDataForDropDown);
			}
		} else if (listOfShipTosFromTrend === undefined) {
			// DO NOTHING. I know this seems sloppy but I mean it really isn't a big deal and not worth my time to find a logical way for ONLY and if and else
			// this means there are no ship tos for this account id. The reason i have this is because i don't want to the program to crash saying something like .ShipTo is not a property.
		} else {
			let formatDataForDropDown = {
				text: listOfShipTosFromTrend.ShipTo + " | " + listOfShipTosFromTrend.CustomerNumber,
				value: listOfShipTosFromTrend.ShipTo
			};

			listOfShipTos.push(formatDataForDropDown);
		}
		await this.setState({ listOfShipTos: listOfShipTos });
	};

	async componentWillUnmount() {
		await this.props.clearUpdateRoomsGlobalState();

		// Change the redux state to display the check prices button on the header
		// Could not think of any other way because this component is not a direct decendant child of the header component.
		// It will be more code than if i were to just use redux
		await this.props.displayCheckPricesButtonOnNavBar(false);
		await this.props.displayCheckProductDetailsOnNavBar(false);
		// await this.props.display_quote_link_on_nav_bar(false);
		await this.props.displayProductShoppingButtonOnNavBar(false);

		// Lastly we want to store the selected ship to for this project before we leave this page so if we go to product shopping we can use that to display non stock
		await this.props.storeThisProjectShipToForDisplayingNonStockInProductShopping;
	}

	createSectionHandler = async event => {
		event.preventDefault();
		let sections = this.props.projectRooms;

		sections.push(
			<Section sectionName={this.state.sectionName} sectionNumber={sections.length} />
		);

		await this.props.saveProjectRooms(sections);
		await this.props.newProjectRoomsToAddToTheDatabase(this.state.sectionName);
		this.setState({ reRender: true });
	};

	callAjax = async (route, data) => {
		this.setState({ roomsLoading: 1 });

		data.trendId = localStorage.getItem("trendId");
		data.token = localStorage.getItem("token");
		let APIResponse = await Axios.post(this.props.APIUrl + route, data);

		if (APIResponse.data.hasOwnProperty("error")) {
			alert(APIResponse.data.error);
			return false;
		}
		this.setState({ response: {}, roomsLoading: 0 });
		return APIResponse.data;
	};

	createRoom = async () => {
		this.setState({ isDisabled: true });
		let newTitle = this.state.sectionName;
		if (newTitle === "") {
			toast.error(translator("Misc", "room_title_error"), {
				position: "bottom-center",
				autoClose: 5000,
				hideProgressBar: false,
				closeOnClick: true,
				pauseOnHover: true,
				draggable: true
			});
		} else {
			let route = "/emco_project_setup/add-room";

			let data = {
				project_id: this.state.projectId,
				title: newTitle
			};

			let response = await this.callAjax(route, data);
			if (response) {
				let rooms = [...this.state.rooms].concat({
					title: newTitle,
					id: parseInt(response["section-id"])
				});
				let updatedRoomNamesForDisplayingRoomsInProductShoppingProductCardDialogBox = [
					...this.props.currentRoomNamesForSelectedProject,
					rooms[rooms.length - 1].title
				];
				let updatedRoomIdsForDisplayingRoomsInProductShoppingProductCardDialogBox = [
					...this.props.currentRoomIdsForSelectedProject,
					rooms[rooms.length - 1].id
				];
				this.props.saveProjectRooms(
					null,
					updatedRoomNamesForDisplayingRoomsInProductShoppingProductCardDialogBox,
					updatedRoomIdsForDisplayingRoomsInProductShoppingProductCardDialogBox
				);

				await this.setState(state => ({
					sectionName: "",
					rooms: rooms
				}));

				// Needed to sort the new room to the bottom
				let orderRoute = "/emco_project_setup/reorder-rooms";
				let orderData = { sections: rooms.map(room => room.id) };
				await this.callAjax(orderRoute, orderData);

				// Check if room is greater than 0. We call this function when we load the page to decide if we should display the product shopping and quote link on the header nav
				// that is why we are doing the code below.
				if (this.state.rooms.length > 0) {
					await this.setState({ room_form_validation_approved: true });
					this.check_if_we_should_display_product_shopping_and_quote_on_nav_bar();
				}
			}
		}
		this.setState({ isDisabled: false });
	};

	getSavedRoomsFromWarehouse = async () => {
		let ajaxURL = this.props.APIUrl + "/emco_settings/get-warehouse-room-titles";
		let data = {
			trendId: localStorage.getItem("trendId"),
			token: localStorage.getItem("token"),
			warehouse: this.state.warehouseNumber
		};
		let roomTitleResponse = await Axios.post(ajaxURL, data);
		if (roomTitleResponse.data.hasOwnProperty("error")) {
			toast.error(
				roomTitleResponse.data.error,
				{
					position: "bottom-center",
					autoClose: 5000,
					hideProgressBar: false,
					closeOnClick: true,
					pauseOnHover: true,
					draggable: true
				}
			);
			$("#create-rooms").addClass("disabled");
			await this.hideHeaderLinks();
			return;
		}
		this.setState({ warehouseRooms: roomTitleResponse.data.roomTitles });
		return;
	};

	// How get newly selected value & remove from list??
	// Button to bring up checkboxes like PB settings might be a bit more manageable??
	createRoomFromSavedList = async (event) => {
		let warehouseRoomsToAddToRooms = this.state.warehouseRoomsToAddToRooms;

		if(!!event.target.checked) {
			warehouseRoomsToAddToRooms[event.target.id] = event.target.value;
		} else {
			let indexToRemove = warehouseRoomsToAddToRooms.indexOf(event.target.value);
			if (indexToRemove > -1) {
				delete warehouseRoomsToAddToRooms[indexToRemove];
			}
		}
		this.setState({ warehouseRoomsToAddToRooms });
	};

	removeRoom = async (e, removeIndex) => {
		this.setState({isDisabled: true});
		let rooms = [...this.state.rooms];
		let route = "/emco_project_setup/delete-room";
		let data = {
			section_id: rooms[removeIndex]["id"],
			is_this_request_from_new_site: true
		};
		let response = await this.callAjax(route, data);
		if (response) {
			rooms.splice(removeIndex, 1);
			await this.setState({ rooms: rooms });

			// -- Get the list of room names and IDs for the product shopping page. I feel like i could have done this in a better way but its too late now we have to store these two values in the redux global state --
			let room_names = [];
			let room_IDs = [];

			for (const room of this.state.rooms) {
				room_names.push(room.title);
				room_IDs.push(room.id);
			}

			await this.props.saveProjectRooms([], room_names, room_IDs);

			// -- Update the database table using this function to call our backend express server --
			this.updateProjectRooms();

			// -- Check if the rooms length is below 0 and if it is then set the room validation as false so the product shopping and quote nav does not display --
			if (this.state.rooms.length === 0) {
				await this.setState({ room_form_validation_approved: false });
				this.hideHeaderLinks();
			}
		}
		this.setState({isDisabled: false});
	};

	changeRoomTItle = async (e, index) => {
		let rooms = [...this.state.rooms];

		if (e.target.value === "") {
			this.setState({ oldRoomName: rooms[index].title });
		}

		rooms[index].title = e.target.value;

		// We used await below just to make sure before the focus out of the input field the update rooms state was saved. Should over use await or it will decrease the performance / speed of your web app.
		await this.setState({ rooms: rooms, did_we_change_room_title: true }); // we use the second state for checking if we shoud send a request to the backend to save the changes in the database table. This is just for performance and to keep our web app fast.

		// ------ The way my code is structured is really bad. I'm seeing how bad it is now. But I was rushing when I first created this project. The below code is neccessary for update the names on product shopping with out refreshing the page. ------

		// -- Get the room names and room IDs --
		let room_names = [];
		let room_IDs = [];

		for (const room of this.state.rooms) {
			room_names.push(room.title);
			room_IDs.push(room.id);
		}

		// -- Save it in the redux state so product shopping can use the updated room titles --
		await this.props.saveProjectRooms(this.state.rooms, room_names, room_IDs);
	};

	save_room_title_changes = async (e, room_index) => {
		console.log("here is the value for the e.target.value in save ", e.target.value);
		if (e.target.value === "") {
			let error_dialog = (
				<Dialog open={true} aria-labelledby="form-dialog-title">
					<DialogTitle id="form-dialog-title set-price-dialog-header">
						<Translated section="Misc" label="error" />
					</DialogTitle>
					<DialogContent style={{ paddingRight: "13em" }}>
						<Translated section="Misc" label="room_title_error" />
					</DialogContent>
					<Button
						id="set-price-close-button"
						onClick={() => this.setState({ updatedProjectPriceDialog: null })}
						color="primary"
					>
						<Translated section="Misc" label="ok_btn" />
					</Button>
				</Dialog>
			);
			let rooms = [...this.state.rooms];
			rooms[room_index].title = this.state.oldRoomName;
			this.setState({
				rooms: rooms,
				oldRoomName: "",
				updatedProjectPriceDialog: error_dialog
			});
		} else {
			if (this.state.did_we_change_room_title) {
				let save_room_title_changes_API_URL =
					this.props.APIUrl + "/room/change-room-title";
				let data = {
					room_ID: this.state.rooms[room_index].id,
					updated_room_title: this.state.rooms[room_index].title
				};
				await Axios.post(
					save_room_title_changes_API_URL,
					data
				);

				this.setState({ did_we_change_room_title: false });

				// -- Update the database table using this function to call our backend express server --
				this.updateProjectRooms();
			}
		}
	};

	rearrangeRooms = async result => {
		if (!result.destination) return;
		this.setState({ isDisabled: true });
		let rooms = [...this.state.rooms];
		let movedRoom = rooms.splice(result.source.index, 1);
		rooms.splice(result.destination.index, 0, movedRoom[0]);
		await this.setState({ rooms: rooms });

		// we also have to set it in redux if we want the sorted list to be applied in all the other pages such as product shopping and project quote
		let sorted_list_of_room_ids = [];
		let sorted_list_of_room_names = [];

		for (const room of this.state.rooms) {
			sorted_list_of_room_ids.push(room.id);
			sorted_list_of_room_names.push(room.title);
		}

		await this.props.saveProjectRooms(null, sorted_list_of_room_names, sorted_list_of_room_ids); // if we pass null for any of the arguments it will not update for that particular redux state
		// ENDS HERE

		let route = "/emco_project_setup/reorder-rooms";
		let data = {
			sections: await rooms.map(room => room.id)
		};

		await this.callAjax(route, data);
		this.setState({ isDisabled: false });
	};

	// Hide header links if project setup data is no longer valid
	hideHeaderLinks = async () => {
		await this.props.displayProductShoppingButtonOnNavBar(false);
		await this.props.displayCheckPricesButtonOnNavBar(false);
		await this.props.displayCheckProductDetailsOnNavBar(false);
		await this.props.display_quote_link_on_nav_bar(false);
	};

	// Show header links if project setup data is made valid
	showHeaderLinks = async () => {
		await this.props.displayProductShoppingButtonOnNavBar(true, this.state.warehouseNumber);
		await this.props.displayCheckPricesButtonOnNavBar(true);
		await this.props.displayCheckProductDetailsOnNavBar(true);
		await this.props.display_quote_link_on_nav_bar(true);
	};

	createOrUpdateCustomer = async (
		event,
		just_checking_to_decide_if_we_should_show_product_shopping_and_quote_header_nav_link = false
	) => {
		try {
			// validate first before you send the data to the backend
			let validationMessage = "";

			if (this.state.firstName === "") {
				validationMessage += translator("Misc", "first_name_error");
			}
			else if (this.state.province === "") {
				validationMessage += translator("Misc", "project_create_province_error");
			}
			else if (!!this.state.postalCode && postalCodes.validate("ca", this.state.postalCode) !== true) {
				validationMessage += postalCodes.validate("ca", this.state.postalCode) + " \n";
			}
			else if (!!this.state.emailAddress && !(/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(this.state.emailAddress))) {
				validationMessage += translator("Misc", "email_invalid_error");
			}
			else if (!this.state.phoneNumber && !this.state.mobilePhoneNumber) { // Check if both numbers are empty
				validationMessage += translator("Misc", "phone_error");
			}
			else if (this.state.phoneNumber.indexOf("_") >= 0 || this.state.mobilePhoneNumber.indexOf("_") >= 0) { //Check if one of the fields is half-filled
				validationMessage += translator("Misc", "phone_error");
			}

			if (validationMessage === "") {
				const customerData = {
					fname: this.state.firstName,
					lname: this.state.lastName,
					address: this.state.address,
					city: this.state.city,
					province: this.state.province,
					postal: this.state.postalCode,
					email: this.state.emailAddress,
					phone_day: this.state.phoneNumber,
					phone_mobile: this.state.mobilePhoneNumber,
					customer_id: this.state.customerId
				};

				let createOrUpdateCustomerUrl = this.props.APIUrl + "/customers/create";

				// This post request can actually be a patch and a post method at the same time
				// one route handler function in the API makes the code more organized
				const createOrUpdateCustomerResponse = await axios.post(
					createOrUpdateCustomerUrl,
					customerData
				);

				// if this was a new customer set the state of the project if not then it will just use
				// the one that we set when we selected it from the drop down OR when we loaded the page
				if (createOrUpdateCustomerResponse.data.newCustomerInformation) {
					this.setState({
						firstName: createOrUpdateCustomerResponse.data.newCustomerInformation.fname,
						lastName: createOrUpdateCustomerResponse.data.newCustomerInformation.lname,
						address: createOrUpdateCustomerResponse.data.newCustomerInformation.address,
						city: createOrUpdateCustomerResponse.data.newCustomerInformation.city,
						province:
							createOrUpdateCustomerResponse.data.newCustomerInformation.province,
						emailAddress:
							createOrUpdateCustomerResponse.data.newCustomerInformation.email,
						phoneNumber:
							createOrUpdateCustomerResponse.data.newCustomerInformation.phone_day,
						mobilePhoneNumber:
							createOrUpdateCustomerResponse.data.newCustomerInformation.phone_mobile,
						customerId: createOrUpdateCustomerResponse.data.newCustomerInformation.id
					});
				}

				if (this.state.isThisAnExistingContactInfo) {
					if (
						just_checking_to_decide_if_we_should_show_product_shopping_and_quote_header_nav_link ===
						false
					) {
						toast.success(translator("Misc", "update_success"), {
							position: "bottom-center",
							autoClose: 5000,
							hideProgressBar: false,
							closeOnClick: true,
							pauseOnHover: true,
							draggable: true
						});
					}
				} else {
					if (
						just_checking_to_decide_if_we_should_show_product_shopping_and_quote_header_nav_link ===
						false
					) {
						toast.success(translator("Misc", "update_success"), {
							position: "bottom-center",
							autoClose: 5000,
							hideProgressBar: false,
							closeOnClick: true,
							pauseOnHover: true,
							draggable: true
						});
					}
				}

				$("#project-information").removeClass("disabled");

				await this.setState({ customer_form_validation_approved: true }); // this is for when we call it in the componentDidMount to decide if we should display the product shopping and quote nav link on the header or not. the other validation functions needs to be true in order to display it on the header for product shopping and the quote link

				if(this.state.project_info_form_validation_approved && !this.state.isThisANewProject) {
					$("#create-rooms").removeClass("disabled");
					this.showHeaderLinks();
				} else {
					this.check_if_we_should_display_product_shopping_and_quote_on_nav_bar();
				}
			} else {
				if (
					just_checking_to_decide_if_we_should_show_product_shopping_and_quote_header_nav_link ===
					false
				) {
					toast.error(validationMessage, {
						position: "bottom-center",
						autoClose: 5000,
						hideProgressBar: false,
						closeOnClick: true,
						pauseOnHover: true,
						draggable: true
					});

					$("#project-information").addClass("disabled");
					$("#create-rooms").addClass("disabled");
					await this.hideHeaderLinks();
				}
			}
		} catch (error) { }
	};

	handleClose = () => {
		this.setState({ open: false });
	};

	createOrUpdateProject = async (
		event,
		just_checking_to_decide_if_we_should_show_product_shopping_and_quote_header_nav_link = false
	) => {
		try {
			// validate first before you send the data to the backend
			let validationMessage = "";
			if (this.state.projectName === "") {
				validationMessage += "please enter the project name \n";
			}
			else if (this.state.warehouseNumber === "" || this.state.warehouseNumber.indexOf("_") >= 0) {
				validationMessage += translator("Misc", "project_create_warehouse_error") + "\n";
			} else if ((this.state.accountName === "" || this.state.accountQuery === "") || (this.state.accountQuery !== this.state.accountName)) {
				// To prevent clearing the account & receiving a success message, since the state only updates when a dropdown option is chosen
				// As accountName is chosen/typed we save a copy of it in accountQuery to ensure accountQuery & accountName are not empty
				validationMessage += translator("Misc", "project_create_account_error") + "\n";
			}
			else if (this.state.listOfShipTos.length > 0 && this.state.shipTo === "") {
				validationMessage += translator("Misc", "project_create_agreement_error") + "\n";
			}

			if (validationMessage === "") {
				const projectData = {
					title: this.state.projectName,
					address: this.state.projectAddress,
					city: this.state.projectCity,
					province: this.state.projectProvince,
					postal: this.state.projectPostalCode,
					warehouse: this.state.warehouseNumber,
					account_name: this.state.accountName,
					ship_to: this.state.shipTo,
					acting_agent: this.state.actingAgent,
					id: this.state.projectId,
					customer_id: this.state.customerId,
					account_id: this.state.accountId,
					edited_by: localStorage.getItem("trendId"),
					language: this.props.selected_language
				};

				let createOrUpdateProjectInformationUrl =
					this.props.APIUrl +
					"/projects/info?warehouseNumber=" +
					this.state.warehouseNumber;

				const createOrUpdateProjectInformationResponse = await axios.patch(
					createOrUpdateProjectInformationUrl,
					projectData
				);

				// Check if we created a new project based on the data we get back from the api using an if statement
				// if we did then set the state for the project information especially the project id because we need that for creating a room and saving it to the database in the createRoom function of this component or it will throw an error
				if (createOrUpdateProjectInformationResponse.data.idForYourNewProject) {
					this.setState({
						projectId: createOrUpdateProjectInformationResponse.data.idForYourNewProject
					});
				}

				await this.getSavedRoomsFromWarehouse();

				let updateProjectPriceAPIUrl =
					this.props.APIUrl + "/projects/update-project-prices";
				let data = {
					projectId: this.state.projectId,
					warehouseNumber: this.state.warehouseNumber,
					accountId: this.state.accountId,
					shipTo: this.state.shipTo,
					//this stuff is for the params for the backend
					trendId: localStorage.getItem("trendId"),
					token: localStorage.getItem("token"),
				};

				let updateProjectPriceAPIResponse = await axios.post(
					updateProjectPriceAPIUrl,
					data
				);

				if (
					updateProjectPriceAPIResponse.data.api_response &&
					updateProjectPriceAPIResponse.data.api_response.changes_made === true
				) {
					if (
						just_checking_to_decide_if_we_should_show_product_shopping_and_quote_header_nav_link ===
						false
					) {
						let dialog = (
							<Dialog open={true} aria-labelledby="form-dialog-title">
								<DialogTitle id="form-dialog-title set-price-dialog-header">
									<Translated section="Misc" label="checked_success" />{" "}
								</DialogTitle>
								<DialogContent style={{ paddingRight: "10em" }}>
									<DialogContentText>
										{updateProjectPriceAPIResponse.data.api_response.updates.map(
											(updatedProductPrice, index) => (
												<React.Fragment key={index}>
													<b>{updatedProductPrice.Vendor_Prod}</b>
													<p>
													{updatedProductPrice.hasOwnProperty('old_price') && (
														<>
															<Translated
																section="Misc"
																label="old_price_label"
															/>
															: {updatedProductPrice.old_price}
															<br />
															<Translated
																section="Misc"
																label="new_price_label"
															/>
															: {updatedProductPrice.price}
														</>
													)}
													{updatedProductPrice.hasOwnProperty('from_catalog') && (
														<div className="product-available"><strong>
															{!!updatedProductPrice.from_catalog 
																? <Translated section="Misc" label="now_unavailable" /> 
																: <Translated section="Misc" label="now_available" />}
														</strong></div>
													)}
													</p>
												</React.Fragment>
											)
										)}
									</DialogContentText>
									<Button
										id="set-center-close-button"
										onClick={this.closeDisplayUpdatedProjectPriceDialog}
										color="primary"
									>
										<Translated section="Misc" label="ok_btn" />
									</Button>
								</DialogContent>
							</Dialog>
						);

						this.setState({ updatedProjectPriceDialog: dialog });
						await this.setState({ project_info_form_validation_approved: true });

						this.check_if_we_should_display_product_shopping_and_quote_on_nav_bar();
					} else {
						// This else statement is for when you load the page and the if statement is used for when you click on confirm
						await this.setState({ project_info_form_validation_approved: true });

						this.check_if_we_should_display_product_shopping_and_quote_on_nav_bar();
					}
				} else if (createOrUpdateProjectInformationResponse.data.validationMessage) {
					if (
						just_checking_to_decide_if_we_should_show_product_shopping_and_quote_header_nav_link ===
						false
					) {
						toast.error(
							createOrUpdateProjectInformationResponse.data.validationMessage,
							{
								position: "bottom-center",
								autoClose: 5000,
								hideProgressBar: false,
								closeOnClick: true,
								pauseOnHover: true,
								draggable: true
							}
						);
						$("#create-rooms").addClass("disabled");
						await this.hideHeaderLinks();
					}
				} else {
					if (
						just_checking_to_decide_if_we_should_show_product_shopping_and_quote_header_nav_link ===
						false
					) {
						this.setState({
							projectLevelId:
								createOrUpdateProjectInformationResponse.data
									.levelIdForYourNewProject
						});
						this.props.saveAccountId(this.state.accountId);
						this.props.saveProjectId(this.state.projectId);

						toast.success(translator("Misc", "save_success"), {
							position: "bottom-center",
							autoClose: 5000,
							hideProgressBar: false,
							closeOnClick: true,
							pauseOnHover: true,
							draggable: true
						});

						$("#create-rooms").removeClass("disabled");
						this.showHeaderLinks();

						await this.setState({ project_info_form_validation_approved: true });
						this.check_if_we_should_display_product_shopping_and_quote_on_nav_bar();
					} else {
						// This else statement is for when you load the page and the if statement is used for when you click on confirm
						await this.setState({ project_info_form_validation_approved: true });
						this.check_if_we_should_display_product_shopping_and_quote_on_nav_bar();
					}
				}
			} else {
				// toast the validation message if we aren't just checking for if there are any validation when loading the page to display the product shopping and quote link on the nav bar
				if (
					just_checking_to_decide_if_we_should_show_product_shopping_and_quote_header_nav_link ===
					false
				) {
					toast.error(validationMessage, {
						position: "bottom-center",
						autoClose: 5000,
						hideProgressBar: false,
						closeOnClick: true,
						pauseOnHover: true,
						draggable: true
					});
					await this.setState({ project_info_form_validation_approved: false });
					$("#create-rooms").addClass("disabled");
					await this.hideHeaderLinks();
				}
			}
		} catch (error) { }
	};

	closeDisplayUpdatedProjectPriceDialog = async event => {
		await this.setState({ updatedProjectPriceDialog: null });

		toast.success(translator("Misc", "save_success"), {
			position: "bottom-center",
			autoClose: 5000,
			hideProgressBar: false,
			closeOnClick: true,
			pauseOnHover: true,
			draggable: true
		});
	};

	checkActingAgent = async event => {
		await this.setState({ actingAgent: !this.state.actingAgent });

		// Modify the record in the database to have the new acting as an agent value cause matt wants it to instantly save
		// If the project Id state doesn't exist it means the project hasn't been created so if they leave this page none of it should be saved including the acting as an agent value
		if (this.state.projectId) {
			let saveActingAsAnAgentAPIUrl =
				this.props.APIUrl + "/projects/update-acting-agent";
			let data = {
				acting_agent: this.state.actingAgent,
				projectId: this.state.projectId
			};
			await axios.post(saveActingAsAnAgentAPIUrl, data);
			this.props.saveActingAsAnAgent(this.state.actingAgent);
		}
	};

	updateProjectRooms = async (
		event,
		just_checking_to_decide_if_we_should_show_product_shopping_and_quote_header_nav_link = false
	) => {

		try {
			// Check if this project has some rooms before going into product shopping
			if (this.state.rooms.length > 0) {
				if (
					just_checking_to_decide_if_we_should_show_product_shopping_and_quote_header_nav_link ===
					false
				) {
					let updateProjectRoomsUrl =
						this.props.APIUrl +
						"/projects/update-rooms";

					let data = {
						roomsIdToDelete: this.props.roomsIdToDelete
							? this.props.roomsIdToDelete
							: false,
						projectId: this.state.projectId ? this.state.projectId : false,
						addedProjectRooms: this.props.addNewProjectRoomsToAddToTheDatabase, // have this to store rooms that they just added
						roomsToUpdate: this.props.updatedRooms,
						isThisANewProject: this.state.isThisANewProject,
						level_id: this.state.projectLevelId
					};

					await axios.post(updateProjectRoomsUrl, data);

					// -- Get the list of room names and IDs for the product shopping page. I feel like i could have done this in a better way but its too late now we have to store these two values in the redux global state --
					let room_names = [];
					let room_IDs = [];

					for (const room of this.state.rooms) {
						room_names.push(room.title);
						room_IDs.push(room.id);
					}

					await this.props.saveProjectRooms([], room_names, room_IDs);

				} else {
					await this.setState({ room_form_validation_approved: true });
					this.check_if_we_should_display_product_shopping_and_quote_on_nav_bar();
				}
			} else {
				if (
					just_checking_to_decide_if_we_should_show_product_shopping_and_quote_header_nav_link ===
					false
				) {
					toast.error(translator("Project Setup", "no_room_error"), {
						position: "bottom-center",
						autoClose: 7000,
						hideProgressBar: false,
						closeOnClick: true,
						pauseOnHover: true,
						draggable: true
					});
				}
			}
		} catch (error) { }
	};

	reRender = async (event, { value }) => {
		value = JSON.parse(value);
		this.setState({
			firstName: value.fname,
			lastName: value.lname,
			address: value.address,
			city: value.city,
			province: value.province,
			postalCode: value.postal,
			emailAddress: value.email,
			phoneNumber: value.phone_day.replace("-", "").replace("-", ""),
			mobilePhoneNumber: value.phone_mobile.replace("-", "").replace("-", ""),
			customerId: value.id,
			isThisAnExistingContactInfo: true
		});
		let obj = new Boolean(this.state.mobilePhoneNumber);
	};

	// The two functions below are used together to prevent the search results crashing when the user types too fast FOR SEARCHING ACCOUNT INFO
	getAccounts = async query => {
		let trendId = localStorage.getItem("trendId");
		let token = localStorage.getItem("token");

		const getAccountInformationAPIUrl = this.props.APIUrl + "/settings/account-information";

		const data = {
			trendId,
			token,
			searchTerm: query,
			warehouse: this.state.warehouseNumber
		};

		const getAccountInformationApiResponse = await Axios.post(
			getAccountInformationAPIUrl,
			data
		);
		let listOfAccountsFromTrend =
			getAccountInformationApiResponse.data.getAccountInformationTrendResponse;

		const listOfAccounts = [];
		if (Array.isArray(listOfAccountsFromTrend)) {
			for (let i = 0; i < listOfAccountsFromTrend.length; i++) {
				let formatDataForInputDropDown = {
					text: listOfAccountsFromTrend[i].Name 
					+ ' | ' + listOfAccountsFromTrend[i].CustomerNumber,
					value: listOfAccountsFromTrend[i].CustomerNumber
				};

				listOfAccounts.push(formatDataForInputDropDown);
			}

			this.setState({ listOfAccounts: listOfAccounts });
		} else if (listOfAccountsFromTrend) {
			let formatDataForInputDropDown = {
				text: listOfAccountsFromTrend.Name 
				+ ' | ' + listOfAccountsFromTrend.CustomerNumber,
				value: listOfAccountsFromTrend.CustomerNumber
			};
			listOfAccounts.push(formatDataForInputDropDown);
			this.setState({ listOfAccounts: listOfAccounts });
		} else {
			this.setState({ listOfAccounts: [] });
		}
	};

	getShipTosSearch = async query => {

		let trendId = localStorage.getItem("trendId");
		let token = localStorage.getItem("token");

		const searchShipTosAPIURL = this.props.APIUrl + "/projects/search-ship-to";

		const data = {
			trendId,
			token,
			projectAccountId: this.state.accountId,
			warehouse: this.state.warehouseNumber,
			query,
		};

		const getSearchShipToAPIResponse = await Axios.post(searchShipTosAPIURL, data);
		let listOfShipTosFromTrend = getSearchShipToAPIResponse.data.listOfShipTosFromTrend;

		const listOfShipTos = [];

		// The reason we have an else statement here is because it crashes when you loop through a non array
		// so the else statement does not have a for loop.
		if (Array.isArray(listOfShipTosFromTrend)) {
			for (let i = 0; i < listOfShipTosFromTrend.length; i++) {
				let formatDataForDropDown = {
					text:
						listOfShipTosFromTrend[i].ShipTo +
						" | " +
						listOfShipTosFromTrend[i].CustomerNumber +
						" | " +
						listOfShipTosFromTrend[i].Name,
					value: listOfShipTosFromTrend[i].ShipTo
				};

				listOfShipTos.push(formatDataForDropDown);
			}
		} else if (listOfShipTosFromTrend === undefined) {
			// DO NOTHING. I know this seems sloppy but I mean it really isn't a big deal and not worth my time to find a logical way for ONLY and if and else
			// this means there are no ship tos for this account id. The reason i have this is because i don't want to the program to crash saying something like .ShipTo is not a property.
		} else {
			let formatDataForDropDown = {
				text: listOfShipTosFromTrend.ShipTo + " | " + listOfShipTosFromTrend.CustomerNumber,
				value: listOfShipTosFromTrend.ShipTo
			};

			listOfShipTos.push(formatDataForDropDown);
		}
		await this.setState({ listOfShipTos: listOfShipTos });
	};

	searchAccounts = query => {
		window.clearTimeout(this.state.searchTimeout);
		this.setState({
			accountName: '',
			accountId: '',
			accountQuery: query,
			searchTimeout: window.setTimeout(this.getAccounts, 500, query)
		});
	};

	searchShipTos = query => {
		window.clearTimeout(this.state.searchTimeout);
		this.setState({
			shipToQuery: query,
			searchTimeout: window.setTimeout(this.getShipTosSearch, 500, query)
		});
	};

	// The two functions below are used together to prevent the search results crashing when the user types too fast FOR SEARCHING ACCOUNT INFO
	searchCustomerInfo = query => {
		window.clearTimeout(this.state.searchTimeout);
		this.setState({
			searchTimeout: window.setTimeout(this.getCustomerInfo, 500, query)
		});
	};

	getCustomerInfo = async query => {
		// Load all the contact info for the user to choose
		const getListOfContactInfoAPIUrl = this.props.APIUrl + "/customers/search-customers";
		const data = {
			query: query
		};
		const getListOfContactInfoAPIResponse = await axios.post(getListOfContactInfoAPIUrl, data);
		let listOfContactInfo = getListOfContactInfoAPIResponse.data.listOfContactInfo;
		const listOfContacts = [];

		for (let i = 0; i < listOfContactInfo.length;) {
			let formatDataForInputDropDown = {
				text:
					listOfContactInfo[i].fname +
					" " +
					listOfContactInfo[i].lname +
					" | " +
					listOfContactInfo[i].address +
					" | " +
					listOfContactInfo[i].phone_day,
				value: JSON.stringify(listOfContactInfo[i]) // we are going to use this to extract the value and insert it into the input field
			};

			listOfContacts.push(formatDataForInputDropDown);

			i++;
		}

		this.setState({ listOfContactInfo: listOfContacts });
	};

	validateEmail = async event => {
		if (!event.target.value) return true;
		if (/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(event.target.value)) {
			return true;
		} else {
			toast.error(translator("Misc", "email_invalid_error"), {
				position: "bottom-center",
				autoClose: 5000,
				hideProgressBar: false,
				closeOnClick: true,
				pauseOnHover: true,
				draggable: true
			});
			return false;
		}
	};

	toastFromSetProjectPricingChildComponent = async (validation, validationMessage) => {
		// Start the loading because it takes a long time to send a request to the back end to check if there
		// was any price changes.
		let loadingDialog = (
			<Dialog open={true} aria-labelledby="form-dialog-title">
				<DialogTitle id="form-dialog-title set-price-dialog-header">
					<Translated section="Misc" label="price_check_dialog_title" /> ...{" "}
				</DialogTitle>
				<DialogContent style={{ paddingRight: "10em" }}>
					<ReactLoader
						style={{ marginLeft: "8em" }}
						type="Oval"
						color="#00BFFF"
						height={50}
						width={50}
					/>
				</DialogContent>
			</Dialog>
		);

		await this.setState({ updatedProjectPriceDialog: loadingDialog });

		// get price changes
		let getPriceChangesResultsAPIUrl =
			this.props.APIUrl + "/projects/update-project-prices-from-trend";
		let data = {
			trendId: localStorage.getItem("trendId"),
			token: localStorage.getItem("token"),
			projectId: this.state.projectId,
		};

		let getPriceChangesResultsAPIResponse = await Axios.post(
			getPriceChangesResultsAPIUrl,
			data
		);

		// create the dialog to display it if there was any price changes
		if (getPriceChangesResultsAPIResponse.data.api_response.changes_made === true) {
			let priceChangesDialog = (
				<Dialog open={true} aria-labelledby="form-dialog-title">
					<DialogTitle id="form-dialog-title set-price-dialog-header">
						<Translated section="Misc" label="checked_success" />{" "}
					</DialogTitle>
					<DialogContent style={{ paddingRight: "10em" }}>
						<DialogContentText>
							{getPriceChangesResultsAPIResponse.data.api_response.updates.map(
								(updatedProductPrice, index) => (
									<React.Fragment key={index}>
										<b>{updatedProductPrice.Vendor_Prod}</b>
										<p>
											{updatedProductPrice.hasOwnProperty('old_price') && (
												<>
													<Translated section="Misc" label="old_price_label" />{" "}: {updatedProductPrice.old_price}
													<br />
													<Translated section="Misc" label="new_price_label" />: {updatedProductPrice.price}
												</>
											)}
											{updatedProductPrice.hasOwnProperty('old_catalog') ? (
												<div className="product-available"><strong>
													{!!updatedProductPrice.from_catalog 
														? <Translated section="Misc" label="now_unavailable" /> 
														: <Translated section="Misc" label="now_available" />}
												</strong></div>
											)
											: ""}
										</p>
									</React.Fragment>
								)
							)}
						</DialogContentText>
						<Button
							style={{ marginLeft: "10em" }}
							id="set-price-close-button"
							onClick={this.closeDisplayUpdatedProjectPriceDialog}
							color="primary"
						>
							<Translated section="Misc" label="ok_btn" />
						</Button>
					</DialogContent>
				</Dialog>
			);
			this.setState({ updatedProjectPriceDialog: priceChangesDialog });
		} else {
			await this.setState({ updatedProjectPriceDialog: null });
			validation === true
				? toast.error(validationMessage, {
					position: "bottom-center",
					autoClose: 7000,
					hideProgressBar: false,
					closeOnClick: true,
					pauseOnHover: true,
					draggable: true
				})
				: toast.success(validationMessage, {
					position: "bottom-center",
					autoClose: 7000,
					hideProgressBar: false,
					closeOnClick: true,
					pauseOnHover: true,
					draggable: true
				});
		}
	};

	sameAsCustomerAddress = async () => {
		await this.setState({
			projectAddress: this.state.address,
			projectCity: this.state.city,
			projectProvince: this.state.province,
			projectPostalCode: this.state.postalCode
		});
	};

	formBody = () => {
		return (
			<div class="quote-dialog-body email-pbook-settings">
				<table>
					<tbody>
						{this.state.warehouseRooms.map((roomTitle, index) => {
							let roomTitleFound = this.state.rooms.some(el => roomTitle.title.toUpperCase() === el.title.toUpperCase());
							return (
								<tr key={roomTitle.id}>
									<td>{roomTitle.title}</td>
									<td>
										<input
											type="checkbox"
											id={index}
											onChange={e => {
												this.createRoomFromSavedList(e);
											}}
											value={roomTitle.title}
											disabled={roomTitleFound}
										/>
										<label htmlFor={index}>
											<div class="email-pbook-checkmark">&#10003;</div>
										</label>
									</td>
								</tr>
							);
						})}
					</tbody>
				</table>
			</div>
		);
	};

	handleSavedRoomTitlesClose = () => {
		if(this.state.roomTitleDialogOpen === true) {
			this.setState({ 
				roomTitleDialogOpen: false,
				warehouseRoomsToAddToRooms: [],
			});
		}
	};

	handleClickOpen = () => {
		if(this.state.roomTitleDialogOpen === false) {
			this.setState({ 
				roomTitleDialogOpen: true,
				warehouseRoomsToAddToRooms: [],
			});
		}
	};

	addSavedRooms = async () => {
		let loadingDialog =
			<Dialog open={true} aria-labelledby="form-dialog-title"><DialogTitle id="form-dialog-title set-price-dialog-header">
				{translator("Misc", "sending_label")}{" "}
			</DialogTitle>
				<DialogContent style={{ paddingRight: "10em" }}>
					<ReactLoader
						style={{ marginLeft: "8em" }}
						type="Oval"
						color="#00BFFF"
						height={50}
						width={50}
					/>
				</DialogContent>
			</Dialog>

		this.setState({ updatedProjectPriceDialog: loadingDialog });

		// Remove empty entries
		let filteredRoomTitles = this.state.warehouseRoomsToAddToRooms.filter(el => el);
		
		let ajaxURL = this.props.APIUrl + "/projects/add-multiple-rooms";
		let data = {
			trendId: localStorage.getItem("trendId"),
			token: localStorage.getItem("token"),
			roomTitles: filteredRoomTitles,
			levelId: this.state.projectLevelId
		};

		let saveRoomTitleResponse = await Axios.post(ajaxURL, data);
		console.log(saveRoomTitleResponse.data);

		if (saveRoomTitleResponse) {
			let rooms = this.state.rooms;

			saveRoomTitleResponse.data.newRoomsCreated.forEach(room => {
				rooms = [...rooms].concat({
					title: room.title,
					id: parseInt(room.id)
				});

				let updatedRoomNamesForDisplayingRoomsInProductShoppingProductCardDialogBox = [
					...this.props.currentRoomNamesForSelectedProject,
					rooms[rooms.length - 1].title
				];
				let updatedRoomIdsForDisplayingRoomsInProductShoppingProductCardDialogBox = [
					...this.props.currentRoomIdsForSelectedProject,
					rooms[rooms.length - 1].id
				];
				this.props.saveProjectRooms(
					null,
					updatedRoomNamesForDisplayingRoomsInProductShoppingProductCardDialogBox,
					updatedRoomIdsForDisplayingRoomsInProductShoppingProductCardDialogBox
				);
			});

			await this.setState({
				sectionName: "",
				rooms: rooms
			});

			// Needed to sort the new room to the bottom
			let orderRoute = "/emco_project_setup/reorder-rooms";
			let orderData = { sections: rooms.map(room => room.id) };
			await this.callAjax(orderRoute, orderData);

			// Check if room is greater than 0. We call this function when we load the page to decide if we should display the product shopping and quote link on the header nav
			// that is why we are doing the code below.
			if (this.state.rooms.length > 0) {
				await this.setState({ room_form_validation_approved: true });
				this.check_if_we_should_display_product_shopping_and_quote_on_nav_bar();
			}
		}

		this.setState({ updatedProjectPriceDialog: null });
		this.handleSavedRoomTitlesClose();
	};

	render() {
		const userToken = localStorage.getItem("token");
		let isDisabled = this.state.isDisabled;
		if (userToken) {
		} else {
			this.setState({ redirect: <Redirect to="/" /> });
		}

		let validationMessage = this.state.validationMessage;

		let currentState = this.state;
		let updatedProjectPriceDialog = this.state.updatedProjectPriceDialog;

		return (
			<div class="container project-setup-page">
				{this.state.redirect}
				{validationMessage}
				<div class="">
					<h1 class="project-setup-header">
						<Translated section="Project Setup" label="page_title" />
					</h1>
					<div class="project-setup-card-wrapper">
						<div class="card w-25 p-3 project-setup-card col-sm">
							<div class="card-body">
								<h5 class="card-title">
									<Translated section="Project Setup" label="contact_heading" />
								</h5>
								<Dropdown
									placeholder={translator(
										"Misc",
										"search_client_dialog_placeholder"
									)}
									fluid
									search
									selection
									options={this.state.listOfContactInfo}
									onChange={this.reRender}
									onSearchChange={(e, d) => {
										this.searchCustomerInfo(d.searchQuery);
									}}
								/>
								<input
									type="text"
									id="exampleForm2"
									class="form-control project-setup-form-control project-setup-mandatory"
									placeholder={translator("Project Setup", "fname_label")}
									maxLength="26"
									onChange={event =>
										this.setState({
											firstName: event.target.value
										})
									}
									value={this.state.firstName}
								/>
								<input
									type="text"
									id="exampleForm2"
									class="form-control project-setup-form-control"
									placeholder={translator("Project Setup", "lname_label")}
									maxLength="26"
									onChange={event =>
										this.setState({
											lastName: event.target.value
										})
									}
									value={this.state.lastName}
								/>
								<input
									type="text"
									id="exampleForm2"
									class="form-control project-setup-form-control"
									placeholder={translator("Project Setup", "address_label")}
									onChange={event =>
										this.setState({
											address: event.target.value
										})
									}
									value={this.state.address}
								/>
								<input
									type="text"
									id="exampleForm2"
									class="form-control project-setup-form-control"
									placeholder={translator("Project Setup", "city_label")}
									onChange={event =>
										this.setState({
											city: event.target.value
										})
									}
									value={this.state.city}
								/>

								<select
									class="btn btn-secondary dropdown-toggle form-control project-setup-form-control project-setup-mandatory"
									type="button"
									id="dropdownMenuButton"
									onChange={event =>
										this.setState({
											province: event.target.value
										})
									}
									value={this.state.province}
								>
									<option value="">
										{translator("Misc", "province_error")} &#8964;
									</option>
									<option value="AB">{translator("Misc", "province_ab")}</option>
									<option value="BC">{translator("Misc", "province_bc")}</option>
									<option value="MB">{translator("Misc", "province_mb")}</option>
									<option value="NB">{translator("Misc", "province_nb")}</option>
									<option value="NL">{translator("Misc", "province_nl")}</option>
									<option value="NT">{translator("Misc", "province_nt")}</option>
									<option value="NS">{translator("Misc", "province_ns")}</option>
									<option value="NU">{translator("Misc", "province_nu")}</option>
									<option value="ON">{translator("Misc", "province_on")}</option>
									<option value="PE">{translator("Misc", "province_pe")}</option>
									<option value="QC">{translator("Misc", "province_qc")}</option>
									<option value="SK">{translator("Misc", "province_sk")}</option>
									<option value="YT">{translator("Misc", "province_yt")}</option>
								</select>
								<br />
								<input
									type="text"
									id="exampleForm2"
									class="form-control project-setup-form-control"
									placeholder={translator("Project Setup", "postal_label")}
									maxLength="6"
									onChange={event =>
										this.setState({
											postalCode: event.target.value
										})
									}
									value={this.state.postalCode}
								/>
								<input
									type="email"
									id="exampleForm2"
									class="form-control project-setup-form-control"
									placeholder={translator("Project Setup", "email_label")}
									onChange={event =>
										this.setState({
											emailAddress: event.target.value
										})
									}
									value={this.state.emailAddress}
								/>
								<InputMask
									mask="999-999-9999"
									value={this.state.phoneNumber}
									class="form-control project-setup-form-control project-setup-mandatory"
									placeholder={translator("Project Setup", "daytime_label")}
									onChange={async event => await this.setState({ phoneNumber: event.target.value })}
								/>
								<div className={"project-setup-or"}>{translator("Misc", "or_label")}</div>
								<InputMask
									mask="999-999-9999"
									value={this.state.mobilePhoneNumber}
									class="form-control project-setup-form-control project-setup-mandatory"
									placeholder={translator("Project Setup", "mobile_label")}
									onChange={async event => await this.setState({ mobilePhoneNumber: event.target.value })}
								/>
								<div className="mandatory-notice">
									<span className="mandatory-box"></span><span className="mandatory-label">- {translator("Misc", "mandatory_fields")}</span>
								</div>
								<button
									onClick={this.createOrUpdateCustomer}
									type="button"
									class="btn btn-primary project-setup-btn"
								>
									<Translated section="Project Setup" label="confirm_btn" />
								</button>
							</div>
						</div>
						<div
							id="project-information"
							class="card w-25 p-3 project-setup-card col-sm"
						>
							<div class="card-body">
								<nav class="navbar navbar-light light-blue lighten-4">
									<a class="navbar-brand project-information-header" href="#">
										<Translated
											section="Project Setup"
											label="project_heading"
										/>
									</a>

									<button
										class="navbar-toggler toggler-example"
										type="button"
										data-toggle="collapse"
										data-target="#navbarSupportedContent-project-information"
										aria-controls="navbarSupportedContent-project-information"
										aria-expanded="false"
										aria-label="Toggle navigation"
									>
										<span class="dark-blue-text">
											<i class="fas fa-bars fa-1x" />
										</span>
									</button>

									<div
										class="collapse navbar-collapse"
										id="navbarSupportedContent-project-information"
									>
										<ul class="navbar-nav mr-auto">
											<li class="nav-item">
												<a
													class="nav-link project-information-header"
													href="#"
												>
													<Translated
														section="Project Setup"
														label="agent_label"
													/>
												</a>
												<div class="" id="navbarNav">
													<ul class="navbar-nav pricing-input-list">
														<li class="nav-item">
															<input
																class={
																	this.props.selected_language ===
																		"en"
																		? "toggle-agent header-toggle-translation"
																		: "toggle-agent-french header-toggle-translation"
																}
																id="actingAgentToggle"
																type="checkbox"
																onClick={this.checkActingAgent}
															/>
														</li>
														<li>
															<FormDialog
																accountName={this.state.accountName}
																shipTo={this.state.shipTo}
																warehouseNumber={
																	this.state.warehouseNumber
																}
																toastFromSetProjectPricingChildComponent={
																	this
																		.toastFromSetProjectPricingChildComponent
																}
																accountId={this.state.accountId}
																actingAsAnAgent={
																	this.state.actingAgent
																}
																projectID={this.state.projectId}
															/>
														</li>
													</ul>
												</div>
											</li>
											<li class="nav-item set-pricing-nav-item">
											</li>
										</ul>
									</div>
								</nav>
								<div class="project-setup-input-wrapper">
									<input
										type="text"
										id="exampleForm2"
										class="form-control project-setup-form-control project-setup-mandatory"
										placeholder={translator(
											"Project Setup",
											"project_name_label"
										)}
										onChange={event =>
											this.setState({
												projectName: event.target.value
											})
										}
										value={this.state.projectName}
									/>
								</div>
								<InputMask
									mask="****" // Need 4 chars total & allow for letters
									maskChar=""
									value={this.state.warehouseNumber}
									class="form-control project-setup-form-control project-setup-mandatory"
									placeholder={translator("Project Setup", "warehouse_label")}
									onChange={event => this.setState({ warehouseNumber: event.target.value })}
									disabled={this.state.warehouseDisabled}
								/>
								<Dropdown
									className="form-control project-setup-form-control project-setup-mandatory"
									placeholder={translator("Project Setup", "account_label")}
									fluid
									search={(options, query) => options}
									selection
									options={this.state.listOfAccounts}
									onChange={(event, { value }) =>
										this.getShipTosForThisAccountId(value)
									}
									onSearchChange={(e, d) => {
										this.searchAccounts(d.searchQuery);
									}}
									value={this.state.accountId}
								/>
								<Dropdown
									className="form-control project-setup-form-control"
									placeholder={
										this.state.listOfShipTos.length > 0
											? translator("Project Setup", "ship_to_label")
											: translator("Misc", "no_ship_to_with_account")
									}
									fluid
									search={(options, query) => options}
									selection
									options={this.state.listOfShipTos}
									onChange={(event, { value }) =>
										this.setState({ shipTo: value })
									}
									onSearchChange={(e, d) => {
										this.searchShipTos(d.searchQuery);
									}}
									value={this.state.shipTo}
								/>

								<br />

								<button
									onClick={this.sameAsCustomerAddress}
									type="button"
									class="btn btn-primary same-as-customer-address-button"
								>
									<Translated section="Project Setup" label="same_address_btn" />
								</button>
								<input
									type="text"
									id="exampleForm2"
									class="form-control project-setup-form-control"
									placeholder={translator(
										"Project Setup",
										"project_address_label"
									)}
									onChange={event =>
										this.setState({
											projectAddress: event.target.value
										})
									}
									value={this.state.projectAddress}
								/>
								<input
									type="text"
									id="exampleForm2"
									class="form-control project-setup-form-control"
									placeholder={translator("Project Setup", "city_label")}
									onChange={event =>
										this.setState({
											projectCity: event.target.value
										})
									}
									value={this.state.projectCity}
								/>
								<select
									class="btn btn-secondary dropdown-toggle form-control project-setup-form-control"
									type="button"
									id="dropdownMenuButton"
									onChange={event =>
										this.setState({
											projectProvince: event.target.value
										})
									}
									value={this.state.projectProvince}
								>
									<option>{translator("Misc", "province_error")} &#8964;</option>
									<option value="AB">{translator("Misc", "province_ab")}</option>
									<option value="BC">{translator("Misc", "province_bc")}</option>
									<option value="MB">{translator("Misc", "province_mb")}</option>
									<option value="NB">{translator("Misc", "province_nb")}</option>
									<option value="NL">{translator("Misc", "province_nl")}</option>
									<option value="NT">{translator("Misc", "province_nt")}</option>
									<option value="NS">{translator("Misc", "province_ns")}</option>
									<option value="NU">{translator("Misc", "province_nu")}</option>
									<option value="ON">{translator("Misc", "province_on")}</option>
									<option value="PE">{translator("Misc", "province_pe")}</option>
									<option value="QC">{translator("Misc", "province_qc")}</option>
									<option value="SK">{translator("Misc", "province_sk")}</option>
									<option value="YT">{translator("Misc", "province_yt")}</option>
								</select>
								<br />
								<input
									type="text"
									id="exampleForm2"
									class="form-control project-setup-form-control"
									placeholder={translator("Project Setup", "postal_label")}
									maxLength="6"
									onChange={event =>
										this.setState({
											projectPostalCode: event.target.value
										})
									}
									value={this.state.projectPostalCode}
								/>
								<div className="mandatory-notice">
									<span className="mandatory-box"></span><span className="mandatory-label">- {translator("Misc", "mandatory_fields")}</span>
								</div>
								<button
									onClick={this.createOrUpdateProject}
									type="button"
									class="btn btn-primary project-setup-btn"
								>
									<Translated section="Misc" label="confirm_btn" />
								</button>

								{updatedProjectPriceDialog}
							</div>
						</div>
						<div id="create-rooms" class="card w-25 p-3 project-setup-card col-sm">
							<div class="card-body project-setup-rooms-card">
								<h5 class="card-title">
									<Translated
										section="Project Setup"
										label="create_section_heading"
									/>
								</h5>

								<div class="input-and-button-wrapper">
									<input
										type="text"
										class="form-control project-setup-form-control"
										placeholder={translator(
											"Project Setup",
											"name_section_label"
										)}
										value={currentState.sectionName}
										onChange={event =>
											this.setState({
												sectionName: event.target.value
											})
										}
									/>
									<button
										onClick={this.createRoom}
										type="button"
										class="btn btn-primary"
										disabled={isDisabled}
									>
										<Translated
											section="Project Setup"
											label="create_section_btn"
										/>
									</button>
								</div>
								{currentState.warehouseRooms.length != 0 && (
									<>
										<div>
											<button
												onClick={this.handleClickOpen}
												type="button"
												class="btn btn-primary saved-rooms-open"
											>
												<Translated section="Admin Room Title Settings" label="title" />
											</button>
										</div>

										<Dialog open={this.state.roomTitleDialogOpen} onClose={this.handleSavedRoomTitlesClose}>
											{this.state.roomTitleDialogLoading}
											<div class="quote-dialog">
												<div class="quote-dialog-title">
													<Translated section="Admin Room Title Settings" label="title" />
												</div>

												{this.formBody()}

												<div class="quote-dialog-footer">
													<button class="quote-dialog-button" onClick={this.handleSavedRoomTitlesClose}>
														<Translated section="Misc" label="close_btn" />
													</button>
													<button class="quote-dialog-button" onClick={this.addSavedRooms}>
														<Translated section="Misc" label="save_label" />
													</button>
												</div>
											</div>
										</Dialog>
									</>
								)}

								<DragDropContext onDragEnd={this.rearrangeRooms}>
									<Droppable droppableId="droppable">
										{(provided, snapshot) => (
											<div
												class="project-setup-rooms-list"
												ref={provided.innerRef}
												{...provided.droppableProps}
											>
												{currentState.rooms.map((room, index) => {
													let newID = room.id
														? "oldroom" + room.id
														: "newroom" + room.newid;
													return (
														<Draggable
															key={newID}
															draggableId={newID}
															index={index}
															isDragDisabled={isDisabled}
														>
															{(provided, snapshot) => (
																<div
																	className={
																		"draggable-inner " +
																		(snapshot.isDragging
																			? "dragged"
																			: "")
																	}
																	ref={provided.innerRef}
																	{...provided.draggableProps}
																	{...provided.dragHandleProps}
																>
																	<i class="fa fal fa-arrows-alt-v section-arrows" />
																	<input
																		type="text"
																		value={room.title}
																		onChange={e =>
																			this.changeRoomTItle(
																				e,
																				index
																			)
																		}
																		onBlur={e =>
																			this.save_room_title_changes(
																				e,
																				index
																			)
																		}
																	/>
																	<Button
																		color="primary"
																		onClick={e =>
																			this.removeRoom(
																				e,
																				index
																			)
																		}
																	>
																		<i
																			class="fa fa-window-close fa-2x"
																			aria-hidden="true"
																		/>
																	</Button>
																</div>
															)}
														</Draggable>
													);
												})}
												{provided.placeholder}
											</div>
										)}
									</Droppable>
								</DragDropContext>
								{currentState.roomsLoading ? (
									<button type="button" class="btn btn-primary confirm-button">
										<i class="fa fa-spinner fa-spin"></i>
									</button>
								) : (
									currentState.rooms && currentState.rooms.length ? (
										<button
											type="button"
											class="btn btn-primary product-shopping-button"
											onClick={() =>
												this.setState({
													redirect: (
														<Redirect
															to={
																"/product-shopping?warehouseNumber=" +
																this.state.warehouseNumber
															}
														/>
													)
												})
											}
										>
											<Translated
												section="Project Setup"
												label="product_shopping_btn"
											/>
										</button> ) :  (
											<button 
												type="button" 
												class="btn btn-primary product-shopping-button"
												onClick={() => 
													toast.error(translator("Project Setup", "no_room_error"), {
														position: "bottom-center",
														autoClose: 7000,
														hideProgressBar: false,
														closeOnClick: true,
														pauseOnHover: true,
														draggable: true
													})
												}
											>
												<Translated
													section="Project Setup"
													label="product_shopping_btn"
												/>
											</button>
										)	
									)}
							</div>
						</div>
					</div>
				</div>
			</div>
		);
	}
}

const mapStateToProps = state => {
	return {
		projectRooms: state.rooms,
		roomsIdToDelete: state.roomsIdToDelete,
		updatedRooms: state.updatedRooms,
		addNewProjectRoomsToAddToTheDatabase: state.addNewProjectRoomsToAddToTheDatabase,
		APIUrl: state.APIUrl,
		actingAgent: state.isThisProjectActingAsAnAgent,
		roomNames: state.roomNames,

		// we need these two states for when creating rooms because we don't want to replace the current ones
		// and product shopping is using the redux roomNames and roomIds state to display the rooms when opening the product card dialog to increase the product quantity for the desired room
		// We are using these two redux states in createRoom function of this component
		currentRoomIdsForSelectedProject: state.roomIds,
		currentRoomNamesForSelectedProject: state.roomNames,
		selected_language: state.selected_language
	};
};

const mapDispatchToProps = dispatch => {
	return {
		saveProjectRooms: (projectRooms, projectRoomNames, projectRoomIds) =>
			dispatch({
				type: actionTypes.SAVE_PROJECT_ROOMS,
				rooms: projectRooms,
				roomNames: projectRoomNames,
				roomIds: projectRoomIds
			}),
		clearUpdateRoomsGlobalState: () =>
			dispatch({
				type: actionTypes.CLEAR_UPDATED_ROOMS_GLOBAL_STATE
			}),
		newProjectRoomsToAddToTheDatabase: roomName =>
			dispatch({
				type: actionTypes.ADD_NEW_PROJECT_ROOM_TO_ADD_TO_THE_DATABASE,
				roomName: roomName
			}),
		saveActingAsAnAgent: actingAsAnAgent =>
			dispatch({
				type: actionTypes.SAVING_ACTING_AS_AN_AGENT,
				saveActingAsAnAgent: actingAsAnAgent
			}),
		displayCheckPricesButtonOnNavBar: displayOrNot =>
			dispatch({
				type: actionTypes.DISPLAY_CHECK_PRICES_BUTTON_ON_NAV_BAR,
				displayOrNot
			}),
		displayCheckProductDetailsOnNavBar: displayOrNot =>
			dispatch({
				type: actionTypes.DISPLAY_CHECK_PRODUCT_DETAILS_ON_NAV_BAR,
				displayOrNot
			}),
		storeThisProjectShipToForDisplayingNonStockInProductShopping: shipToName =>
			dispatch({
				type:
					actionTypes.STORE_THIS_PROJECT_SHIP_TO_FOR_DISPLAYING_NON_STOCK_IN_PRODUCT_SHOPPING,
				shipToName
			}),
		displayProductShoppingButtonOnNavBar: (
			displayOrNot,
			selected_project_warehouse_number = "warehouse_number_has_not_been_provided_for_this_project"
		) =>
			dispatch({
				type: actionTypes.DISPLAY_PRODUCT_SHOPPING_BUTTON_ON_NAV_BAR,
				displayOrNot,
				selected_project_warehouse_number
			}),
		saveAccountId: accountId =>
			dispatch({
				type: actionTypes.SAVE_ACCOUNT_ID_FOR_GETTING_PRODUCT_INFORMATION_LATER,
				accountId: accountId
			}),
		saveProjectId: projectId =>
			dispatch({
				type: actionTypes.SAVE_PROJECT_ID_TO_INCREASE_THE_QUANTITY_OF_A_PRODUCT,
				projectId: projectId
			}),
		display_quote_link_on_nav_bar: displayOrNot =>
			dispatch({
				type: actionTypes.DISPLAY_QUOTE_LINK_ON_NAV_BAR,
				displayOrNot
			}),
		saveProjectRooms: (projectRooms, projectRoomNames, projectRoomIDs) =>
			dispatch({
				type: actionTypes.SAVE_PROJECT_ROOMS,
				rooms: projectRooms,
				roomNames: projectRoomNames,
				roomIds: projectRoomIDs
			}),
	};
};
export default connect(mapStateToProps, mapDispatchToProps)(NewProject);
